/** 
 * Validation of search form and ciudades
 */
import { langDict } from "./dict.js";
import { check_same_office } from "./offices.js";
import { logger, dId, dQS, showError } from "./utils.js";
import { search_type, ciudad_dropdown_furgo, ciudad_dropdown_turismo, ciudades_index,reservaD } from "./variables.js";



/**
 * @param element inp 
 * Validate that the input value is one of the possible city items
 * If correct then set ciudad ID to match selection
 * If not, then show error class on element.
 */
function validate_dropdown_ciudades(inp: string) {

  logger("Check for search match: " + inp);

  // Reset hidden fields, so cant submit with error visible on screen; 
  if (inp == "oficina_salida_selector") {
    reservaD[15] = "reset";
    (<HTMLInputElement>dId("f_ciudad")).value = "reset";
  } else {
    reservaD[16] = "1000";
    (<HTMLInputElement>dId("d_ciudad")).value = "reset";
  }

  let err = false;
  let node = (<HTMLInputElement>dId(inp));

  node.classList.remove("searchform-err");

  let arr = (search_type === "F") ? ciudad_dropdown_furgo : ciudad_dropdown_turismo;

  /* if empty just return without error class */
  if (node.value == "") {
    logger("No ciudad value to check!", "log");
    err = true;
    return;
  }

  /* if return and type is not one way, just return */
  if ((<HTMLInputElement>dId("sel_misma_oficina")).checked == false 
    && inp == "oficina_devolucion_selector") {
    return;
  }

  /* Check if in array */
  if (arr.indexOf(node.value) < 0) {
    err = true;
    node.classList.add("searchform-err");
    return;
  }

  let matched = false;

  // Made it here, so set a value on the hidden form:
  // [city match, city name, provincia_name, provincia int, (ciudad int), (tipo)]
  ciudades_index.forEach(elem => {

    if (elem[0] == node.value.trim()) {

      console.warn(elem);

      logger("update " + inp + " id \n To: " + elem[1] + ". \nProv: " + elem[2] + " with id: " + elem[3] + " City " + elem[4] + " Pais " + elem[5], " log");

      if (inp == "oficina_salida_selector") {

        (<HTMLInputElement>dId("f_ciudad")).value = elem[1];

        reservaD[6] = elem[2]; // Texto of provincia salida
        reservaD[15] = elem[3]; // index of provincia salida
        reservaD[36] = elem[4]; // index of pais salida

        check_same_office();

      } else {

         (<HTMLInputElement>dId("d_ciudad")).value = elem[1];

        reservaD[11] = elem[2]; // Texto of provincia devolucion
        reservaD[16] = elem[3]; // index of provincia devolucion
        reservaD[37] = elem[4]; // index of pais devolucion
        
      }

      matched = true;
      logger("set " + inp + " id to: " + elem[3] + " " + elem[2], "log");
      return;

    }

  });

  if (!matched) {
    logger("Error: " + node.value + " not found in ciudades_index","error");
  }

}


/** Validate search form before allowing submit */
function validate_search_form() {

	const re_date = /^\d{4}\-\d{2}\-\d{2}$/;
	const re_time = /^\d{2}:\d{2}$/;

	const form_elems = ["#f_provincia, #f_ciudad, #hora_salida, #hora_vuelta, #fecha_salida, #fecha_vuelta"];

  form_elems.forEach((e) => {
    dQS(e)?.classList.remove("f_error");
  });
  

  // Vehicle Check: 
  const v = (<HTMLInputElement>dQS("#f_tipo_vehiculo")).value; 
  if (v == "0") {
    showError(langDict[4]);
    return false;
  } else {
    reservaD[7] = v;
  }

  
  // Provincia Salida Check:
 
  if (reservaD[15] == "1000" || reservaD[15] == "") {
    showError(langDict[5]);
    return false;
  } 

  // Ciudad Salida Check
  const c = (<HTMLInputElement>dQS("#f_ciudad"));
  if (c.value == "reset" || c.value == "") {
   
    c.classList.add("f_error");
    showError(langDict[6]);
    return false;

  } else {

    reservaD[12] = c.value;
    reservaD[13] = c.value;

  }
	

  // One way check (checked means IS one way):
  const ow = (<HTMLInputElement>dQS("#sel_misma_oficina")).checked;
  const c_d = (<HTMLInputElement>dQS("#d_ciudad"));

  if (ow) {

    reservaD[8] = 1;

    if (reservaD[16] == "1000" || reservaD[16] == "") {

      showError(langDict[7]);
      return false;
    }

    if (c_d.value == "reset" || c_d.value == "") {
   
      c_d.classList.add("f_error");
      showError(langDict[8]);
      return false;

    } 

    reservaD[13] = c_d.value;


  } else {

    reservaD[8] = 0;
    reservaD[16] = "1000";
    reservaD[13] = "";

  }



  // Date Checks:
  // Date must be saved as DD/MM/YYYY - Convert to YYYY-MM-DD for storage
 
	const fd = (<HTMLInputElement>dId("fecha_salida"));
	const fh = (<HTMLSelectElement>dId("hora_salida"));
	const td = (<HTMLInputElement>dId("fecha_vuelta"));
	const th = (<HTMLSelectElement>dId("hora_vuelta"));

  // Check that from date is not after to date:
  const fdd = new Date(fd.value + " " + fh.value);
  const tdd = new Date(td.value + " " + th.value);
	
  // convert to DD/MM/YYYY for display:
  const fd_euro:string  = ("0" + fdd.getDate()).slice(-2) + "/" + ("0" + (fdd.getMonth() + 1)).slice(-2) + "/" + fdd.getFullYear();

  const td_euro:string  = ("0" + tdd.getDate()).slice(-2) + "/" + ("0" + (tdd.getMonth() + 1)).slice(-2) + "/" + tdd.getFullYear();

	if (!re_date.test(fd.value)) {
    fd.classList.add("f_error");
    showError(langDict[9]);
		return false;
	} else {
    reservaD[1] = fd_euro;
    reservaD[9] = fd.value;
  
  }


  if (!re_date.test(td.value)) {
    td.classList.add("f_error");
    showError(langDict[10]);
		return false;
	} else {
    reservaD[3] = td_euro;
    reservaD[10] = td.value;
  }

	
	if (tdd < fdd) {
    td.classList.add("f_error");
		showError(langDict[11]);
		return false;
	}



	if (!re_time.test(fh.value)) {
		showError(langDict[12]);
    fh.classList.add("f_error");
		return false;
	} else {
    reservaD[2] = fh.value;
  }


  if (!re_time.test(th.value)) {
		showError(langDict[12]);
    th.classList.add("f_error");
		return false;
	} else {
    reservaD[4] = th.value;
  }


	// Over 31 days - show error:
	const diff = Math.abs(tdd.getTime()- fdd.getTime() );
	const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));

  logger("Days calculated: " + diffDays, "log");

	if (diffDays > 31) {
		showError(langDict[120]);
		return false;
	} else {
    reservaD[5] = diffDays;
  }


  // Young driver: 
  const yd = (<HTMLInputElement>dQS("#mayor_edad")).checked;
  reservaD[14] = (yd) ? "Si" : "No";
  

	return true;

}


export { validate_dropdown_ciudades, validate_search_form };